<template>
  <div class="register-page page">
    <div class="page-mask"></div>
    <div class="page-content">
      <div class="top-bar">
        <van-icon name="arrow-left" class="back-icon" @click="back" />
        <div class="page-title">{{ $t("auth.register") }}</div>
        <div class="top-right"></div>
      </div>

      <div class="wrapper">
        <div class="logo-wrap">
          <img class="logo-image" src="/img/login/eharmony-logo.png" alt="logo" />
        </div>

        <div class="register-form">
          <van-field
            v-model.trim="username"
            clearable
            input-align="center"
            class="input"
            :placeholder="$t('auth.username_place')"
          />

          <van-field
            v-model="password"
            :type="passwordType"
            input-align="center"
            class="input"
            :placeholder="$t('auth.pwd_place')"
          >
            <template slot="right-icon">
              <van-icon
                :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                class="password-icon"
                @click="switchPasswordType"
              />
            </template>
          </van-field>

          <van-field
            v-model.trim="code"
            clearable
            input-align="center"
            class="input"
            :placeholder="$t('auth.invite_code_place')"
          />

          <div class="agreement" @click="checked = !checked">
            <van-checkbox v-model="checked" checked-color="#5f63e1" @click.stop />
            <span class="agreement-text">{{ $t("auth.agreement_place") }}</span>
          </div>

          <van-button class="register-btn" type="default" @click="doRegister">
            {{ $t("auth.register") }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: "",
      code: "",
      lang: "en",
      password: this.inputValue,
      passwordType: "password",
    };
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || this.$t("auth.lang") || "en";
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (!this.username) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }

      if (!this.password) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }

      if (!this.code) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }

      if (!this.checked) {
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }

      this.$http({
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang,
        },
        url: "member_register",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data);
          this.$router.push({ path: "/Mine" });
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.register-page {
  position: relative;
  min-height: 100%;
  overflow: hidden;
  background: linear-gradient(180deg, #ecb3c1 0%, #d5bee4 42%, #5d62dc 100%);
}

.page-mask {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(236, 179, 193, 0.88) 0%, rgba(213, 190, 228, 0.5) 42%, rgba(123, 118, 221, 0.36) 68%, rgba(93, 98, 220, 0.2) 100%),
    url("/img/login/logo_bg.jpg") no-repeat center bottom / cover;
  opacity: 0.9;
}

.page-mask::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 46%;
  background: linear-gradient(180deg, rgba(96, 103, 229, 0) 0%, rgba(97, 104, 229, 0.45) 28%, rgba(94, 101, 224, 0.85) 100%);
}

.page-content {
  position: relative;
  z-index: 1;
  min-height: 100%;
}

.top-bar {
  display: grid;
  grid-template-columns: 72px 1fr 72px;
  align-items: center;
  padding: 18px 12px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.45);
}

.page-title {
  text-align: center;
  color: #000;
  font-size: 26px;
  line-height: 40px;
  text-transform: lowercase;
}

.top-right {
  width: 72px;
  height: 72px;
}

.back-icon {
  justify-self: start;
  color: #6f5f7d;
  font-size: 56px;
}

.wrapper {
  padding: 8px 28px 0;
}

.logo-wrap {
  display: flex;
  justify-content: center;
  margin: 8px 0 44px;
}

.logo-image {
  width: 128px;
  height: 128px;
  border-radius: 26px;
  object-fit: cover;
  box-shadow: 0 10px 24px rgba(105, 73, 87, 0.14);
}

.register-form {
  padding-bottom: 120px;
}

.input {
  width: 100%;
  margin-bottom: 28px;
  min-height: 92px;
  border: none;
  border-radius: 46px;
  overflow: hidden;
}

::v-deep .input.van-cell {
  width: 100%;
  margin-bottom: 28px;
  padding: 0 28px;
  min-height: 92px;
  border: none;
  border-radius: 46px;
  background: rgba(112, 93, 130, 0.86);
}

::v-deep .input.van-cell::after {
  display: none;
}

.agreement {
  display: flex;
  align-items: flex-start;
  margin: 8px 0 26px;
  color: #fff;
  cursor: pointer;
}

.agreement-text {
  margin-left: 14px;
  font-size: 25px;
  line-height: 34px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.94);
}

.register-btn {
  width: 100%;
  height: 92px;
  border: none;
  border-radius: 46px;
  background: #d6d6d6;
  box-shadow: none;
  font-size: 34px;
  font-weight: 700;
  color: #5463f0;
  text-transform: lowercase;
}

::v-deep .van-field__body {
  min-height: 92px;
}

::v-deep .van-field__control {
  color: #fff;
  font-size: 28px;
  line-height: 40px;
}

::v-deep .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.88);
}

::v-deep .van-field__right-icon {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.74);
}

.password-icon {
  font-size: 42px;
}

::v-deep .agreement .van-checkbox {
  flex-shrink: 0;
}

::v-deep .agreement .van-checkbox__icon {
  font-size: 34px;
  line-height: 34px;
}

::v-deep .agreement .van-icon-success {
  background-color: #5f63e1;
  border-color: #5f63e1;
}

::v-deep .agreement .van-checkbox__label {
  display: none;
}

::v-deep .van-button__text {
  letter-spacing: 1px;
}

::v-deep .van-nav-bar {
  background: transparent;
}

::v-deep .van-checkbox {
  display: flex;
  align-items: flex-start;
}
</style>
